import { useEffect, useState } from'react';
import { message } from 'antd';
import { debounce } from "@/utils"
import { ResDataType } from '@/services/ajax';
import { channelList,ChannelListResType } from '@/services/channel';
const useChannelList = () => {
    const [channelName,setChannelName] = useState('');
    const [curChannelList,setChannelList] = useState<ChannelListResType[]>([]);
    const getChannelList = async (name:string = '') => {
        const res = await channelList({PageIndex:1,PageSize:20,Name:name}) as ResDataType;
        if (res.code!= 0) {
            message.error(res.message);
            return;
        }
        const list = res.data.list.map((item:ChannelListResType)=> {
            return {label:item.name,value:item.id} 
        })
        setChannelList(list);
    }

    const debouncedSearch = debounce((value:string) => {
        getChannelList(value)
    }, 300);
    
    const handleSearch = (value:string) => {
        debouncedSearch(value);
    };
    return {
        channelName,curChannelList,handleSearch,setChannelName,getChannelList
    };
};

export default useChannelList;